import React from 'react';
import styled from 'styled-components';
import { Button as ButtonOwned } from '@lt/components';

type WidthType = React.CSSProperties['width'];

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  functional?: boolean;
  isLoading?: boolean;
  width?: WidthType;
  className?: string;
  size?: string;
}

export const ButtonWithLoader: React.FC<Props> = ({
  children,
  isLoading = false,
  width,
  className,
  size,
  ...rest
}) => (
  <Container _width={width} className={className}>
    <Loader _visible={isLoading} />
    <StyledButton _width={width} size={size} {...rest}>
      {!isLoading && children}
    </StyledButton>
  </Container>
);
export const Container = styled.div<{ _width?: WidthType }>`
  position: relative;
  display: inline-flex;
  width: ${({ _width }) => _width ?? 'auto'};
  margin-top: 16px;
`;

export const Loader = styled.div<{ _visible?: boolean }>`
  display: ${({ _visible }) => (_visible ? 'block' : 'none')};
  position: absolute;
  width: 16px;
  height: 16px;
  left: calc(50% - 16px / 2);
  top: calc(50% - 16px / 2 - 1px);
  border: 2px solid #f5a623;
  border-right-color: transparent;
  border-radius: 50%;
  animation: loadingspin 1s linear infinite;

  @keyframes loadingspin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledButton = styled(ButtonOwned)<{ _width?: WidthType }>`
  width: ${({ _width }) => _width ?? 'auto'};
`;
